import { usePatientDetails } from '../../contexts/PatientDetailsContext';
import { PatientProfile } from './PatientProfile';

export function GlobalPatientWindows() {
  const { openPatients, closePatient } = usePatientDetails();

  // Render all non-minimized open patient windows
  return (
    <>
      {Array.from(openPatients.entries()).map(([patientId, entry]) =>
        !entry.isMinimized && (
          <PatientProfile
            key={patientId}
            patient={entry.patient}
            open={true}
            onClose={() => closePatient(patientId)}
            appointment={entry.appointment}
            initialSection={entry.initialSection}
          />
        )
      )}
    </>
  );
}
